import { Checkbox, FormControlLabel, Typography } from "@mui/material";
import { Controller, Control, FieldPath, FieldValues } from "react-hook-form";
import { ReactNode } from "react";

interface FormCheckboxProps<T extends FieldValues> {
  name: FieldPath<T>;
  control: Control<T>;
  label: string | ReactNode;
  required?: boolean;
}

export const FormCheckbox = <T extends FieldValues>({
  name,
  control,
  label,
  required = false,
}: FormCheckboxProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <>
          <FormControlLabel
            control={
              <Checkbox
                {...field}
                checked={field.value || false}
                size="medium"
                sx={{ width: 48, height: 48, color: "#ffd200" }}
              />
            }
            label={
              typeof label === "string" ? (
                <Typography variant="body1" fontSize={16}>
                  {label}
                </Typography>
              ) : (
                label
              )
            }
          />
          {error && (
            <Typography color="error" variant="caption">
              {error.message}
            </Typography>
          )}
        </>
      )}
    />
  );
};
